import { useState } from 'react';
import { accessJsonAttr, convertToLocaleDateString, isMobile } from '../../utils/utils';
import MgpFormInput from '../MgpFormInput/MgpFormInput';
import MgpIcon from '../MgpIcon/MgpIcon';
import { MgpDatepickerProps } from './MgpDatePicker.types';

export default function MgpDatePicker({id, label, required, register, errors = {}, disabled, handleChange, ...props }: MgpDatepickerProps) {

    const [value, setValue] = useState(props.value ? convertToLocaleDateString(props.value) : '');

    let labelClassName = "form-check-label text";
    let fieldError;
    let inputClassName = "form-control";
    if(errors) {
        fieldError = accessJsonAttr(errors, id);
        if(fieldError) {
          labelClassName += " form-error";
          inputClassName += " form-error";
        }
    }

    const onChangeEvent = (e: any) => {
        let inputDate = e.target.value;

        inputDate = inputDate.replace(/[^0-9]/g, '');

        let day = inputDate.slice(0, 2);
        let month = inputDate.slice(2, 4);
        let year = inputDate.slice(4, 8);
    
        if (day && (day.length > 2 || parseInt(day, 10) > 31)) {
            day = inputDate.slice(0, 2);
        }
    
        if (month && (month.length > 2 || parseInt(month, 10) > 12)) {
            month = inputDate.slice(2, 4);
        }

        if (year && year.length > 4) {
            year = inputDate.slice(4, 8);
        }
    
        let formattedDate =  `${day ? day + '/' : ''}${month ? month + '/' : ''}${year}`;
        
        setValue(formattedDate);
        handleChange(`${year}-${month }-${day}`);  
    }

    const handleDelete = (e: any) => {
        const { keyCode } = e.nativeEvent;
        if (keyCode === 8 || keyCode === 46) { 
            setValue('');
            handleChange('');  
          } 
    }

    
    if (isMobile()) {
        return (
            <div>
                {label&&<label className={labelClassName} htmlFor={id}>
                    {label}{required ? <span className='fushia'> (*)</span>: ''}
                </label>}
                <div className="input-withicon-right">
                    <input  {...props} type='text' className={inputClassName} id={id}  onChange={(e) => {onChangeEvent(e)}} 
                        value={value} 
                        placeholder="jj/mm/aaaa"
                        onKeyDown={(e) => handleDelete(e)}
                        maxLength={10}
                    />
                   <MgpIcon icon='calendrier' color='bleu' />
                </div>
                {fieldError && (<p className="error">{fieldError.message}</p>)}
            </div> 
        );

    } else {
        return (
             <MgpFormInput
                label={label}
                id={id}
                icon='calendrier'
                type='date'
                iconPosition='right'
                register={register}
                errors={errors}
                labelFontWeight='regular'
                required={true}
                disabled={disabled}
                />
        )
    }
 
}
